import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date | null | undefined, now = Date.now()): string {
    if (!value) return '';

    const createdAt = new Date(value);
    const diffSec = Math.floor((now - createdAt.getTime()) / 1000);

    if (diffSec < 60) return 'just now';

    const units: [string, number][] = [
      ['y', 31536000],
      ['mo', 2592000],
      ['d', 86400],
      ['h', 3600],
      ['m', 60],
    ];

    for (const [label, sec] of units) {
      if (diffSec >= sec) {
        return `${Math.floor(diffSec / sec)}${label} ago`;
      }
    }

    return '';
  }
}
